import { flowRight } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from '../../../common/components/runtime-context';
import Link from '../link/internal-link';
import IconTooltip from '../icon-tooltip';
import styles from './best-answer-icon-link.scss';
import { SolvedIcon } from '../icons/solved-icon';

const BestAnswerIconLink = ({
  t,
  toolTipClassName,
  iconClassName,
  linkComponent: LinkComponent,
  resolveCommentDeepLinkUrl,
  commentId,
}) => (
  <IconTooltip text={t('comment.solved')} className={toolTipClassName}>
    <LinkComponent
      dynamicLocationResolver={() => resolveCommentDeepLinkUrl(commentId)}
      className={styles.link}
      to={`/main/comment/${commentId}`}
      aria-label={t('comment.solved.label')}
    >
      <SolvedIcon className={classNames(iconClassName, 'button-fill')} />
    </LinkComponent>
  </IconTooltip>
);

BestAnswerIconLink.propTypes = {
  commentId: PropTypes.string,
  toolTipClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  linkComponent: PropTypes.any,
  resolveCommentDeepLinkUrl: PropTypes.func,
  t: PropTypes.func,
};

BestAnswerIconLink.defaultProps = {
  linkComponent: Link,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  resolveCommentDeepLinkUrl: actions.resolveCommentDeepLinkUrlPromisified,
});

export default flowRight(connect(mapRuntimeToProps))(BestAnswerIconLink);
